package nl.staartvin.solarpower.data.net

import kotlinx.serialization.json.Json

val AppJson: Json = Json {
    ignoreUnknownKeys = true
    explicitNulls = false
}
